export const FOOTER_ANCHOR_CLASSES = 'flex flex-column justify-between min-vh-100';
